import { render, staticRenderFns } from "./GlossCodePill.vue?vue&type=template&id=5a99aa3a"
import script from "./GlossCodePill.vue?vue&type=script&lang=js"
export * from "./GlossCodePill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports